import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Token swatch fixture page (design-system visual gate teeth).
 * Renders every CSS token as a labeled swatch so visual:check can detect
 * ANY token change (practice per industry visual-fixture pipelines; #292).
 * Route: /dev/tokens — linked nowhere in prod navigation.
 */
const GROUPS: Array<[string, string[]]> = [
  ["brand", ["--color-buy", "--color-buy-hover", "--color-sell", "--color-sell-hover", "--color-warning", "--color-info", "--success", "--danger"]],
  ["bg", ["--bg-primary", "--bg-secondary", "--bg-tertiary", "--bg-hover", "--bg-active", "--bg-input", "--bg-card", "--bg-tooltip"]],
  ["border", ["--border-primary", "--border-hover", "--border-active"]],
  ["text", ["--text-primary", "--text-secondary", "--text-tertiary", "--text-muted"]],
];

export default function TokenFixturePage() {
  const nav = useNavigate();
  const [css, setCss] = useState<Record<string, string>>({});
  useEffect(() => {
    const s = getComputedStyle(document.documentElement);
    const out: Record<string, string> = {};
    for (const [, vars] of GROUPS) for (const v of vars) out[v] = s.getPropertyValue(v).trim();
    setCss(out);
  }, []);
  return (
    <div className="p-8" data-testid="token-fixture">
      <h1 className="text-lg mb-4">Design Token Fixture</h1>
      {GROUPS.map(([group, vars]) => (
        <section key={group} className="mb-6">
          <h2 className="text-sm mb-2">{group}</h2>
          <div className="flex flex-wrap gap-3">
            {vars.map((v) => (
              <div key={v} className="w-40">
                <div style={{ background: `var(${v})`, height: 48, border: "1px solid var(--border-primary)" }} />
                <div className="text-xs mt-1 font-mono">{v}</div>
                <div className="text-xs" style={{ color: "var(--text-secondary)" }}>{css[v]}</div>
              </div>
            ))}
          </div>
        </section>
      ))}
      <button className="mt-4 text-xs underline" onClick={() => nav(-1)}>back</button>
    </div>
  );
}
